import "@progress/kendo-ui/js/kendo.core.js";      // ⚙️ charge le Core
import "@progress/kendo-ui/js/kendo.data.js";      // modules de data binding
import "@progress/kendo-ui/js/kendo.popup.js";

import "@progress/kendo-ui/esm/kendo.splitter.js";
import "@progress/kendo-ui/esm/kendo.toolbar.js";
import "@progress/kendo-ui/esm/kendo.form.js";
import "@progress/kendo-ui/esm/kendo.grid.js";
import "@progress/kendo-ui/esm/kendo.dialog.js";
import "@progress/kendo-ui/esm/kendo.window.js";
import "@progress/kendo-ui/esm/kendo.treeview.js";
import "@progress/kendo-ui/esm/kendo.loader.js";
import "@progress/kendo-ui/esm/kendo.tabstrip.js";
import "@progress/kendo-ui/esm/kendo.textbox.js";
import "@progress/kendo-ui/esm/kendo.dropdownlist.js";
import "@progress/kendo-ui/esm/kendo.notification.js";
import "@progress/kendo-ui/esm/kendo.editor.js";

import "@progress/kendo-ui/esm/cultures/kendo.culture.fr-FR.js";
import "@progress/kendo-ui/esm/messages/kendo.messages.fr-FR.js";

import { initMonaco } from "./monaco/initMonaco.js";
await initMonaco();

import {NotificationToolbar} from "./Helper/NotificationHelper.js";
import {OnTokenLogin, TokenHelper} from "./Helper/TokenHelper.js";
import {MainMenu} from "./Component/MainMenu.js";
import {ClientTab} from "./Component/Client/ClientTab.js";
import {ProjetTab} from "./Component/Projet/ProjetTab.js";
import {Controler, ControlerList, IControlerAfterLoadEvent} from "./Tools/Circular.Object.js";
import {UrlHash} from "./Tools/Url.js";
import {Header} from "./Component/Header.js";
import {Config} from "./config/Config.js";
import {IConfigInterface} from "./config/IConfigInterface.js";
import {OnFetchVersionChanged} from "./Delegates/FetchDelegate";
import {RessourceSlot} from "./Tools/Disposable/RessourceSlot";
import {DisposableStack} from "./Tools/Disposable/DisposableStack";

document.addEventListener("DOMContentLoaded", async () => {
    const destinationContent = $(document.querySelector("#page-container"));
    const sourcePool = $(document.querySelector("#source-container"));

    kendo.culture("fr-FR");

    console.log("Chargement de la configuration ...");
    const env = (window as any).APP_ENV?.toLowerCase();
    console.log("Environnement : ", env);
    const bUrl = "/";
    const moduleConfig = import(`${bUrl}dist/config/config.${env}.js`);
    const {default: cfg} = await moduleConfig;
    Config.Set(cfg as IConfigInterface);

    OnTokenLogin.Bind(async () => {
        await ControlerList.Instance.Navigate("#/Home/Index");
        new MainMenu({
            jqMainContainer: $("#panel-middle-left")
        });
    });

    OnFetchVersionChanged.Bind(async (e: string) => {
        NotificationToolbar.Instance.BoVersionMessage(e).then();
    })
    

    ControlerList.Instance.Bind(new Controler({
        Nom: "Home Index",
        Title: "Accueil",
        Id: "home-index",
        Route: "/Home/Index",
        Destination: $(destinationContent),
        SourcePool: $(sourcePool),
        LoadCallBack: () => {

        }
    })).then();

    ControlerList.Instance.Bind(new Controler({
        Nom: "Home Page 2",
        Title: "Page 2",
        Id: "home-page2",
        Route: "/home/Page2",
        SourcePool: $(sourcePool),
        Destination: $(destinationContent),
        LoadCallBack: () => {

        }
    })).then();

    ControlerList.Instance.Bind(new Controler({
        Nom: "Client",
        Title: "Client",
        Id: "client",
        Route: "/client",
        SourcePool: $(sourcePool),
        Destination: $(destinationContent),
        LoadCallBack: (e: IControlerAfterLoadEvent) => {
            e.Controler.DisposableStack.Reset();
            const p = new RessourceSlot<ClientTab>();
            p.Reset(() => new ClientTab({
                jqMainContainer: e.Controler.Content,
                clientId: UrlHash.GetQueryDatas.Get("id").Value
            }));
            p.Value.Init();
            e.Controler.DisposableStack.Use(p);
        }
    })).then();

    ControlerList.Instance.Bind(new Controler({
        Nom: "Projet",
        Title: "Projet",
        Id: "projet",
        Route: "/projet",
        SourcePool: $(sourcePool),
        Destination: $(destinationContent),
        LoadCallBack: (e: IControlerAfterLoadEvent) => {
            e.Controler.DisposableStack.Reset();
           const p = new RessourceSlot<ProjetTab>();
           p.Reset(() => new ProjetTab({
                jqMainContainer: e.Controler.Content,
                projetId: UrlHash.GetQueryDatas.Get("id").Value
            }));
            p.Value.Init();
            e.Controler.DisposableStack.Use(p);
        }
    })).then();

    console.log("Routeur : ", ControlerList.Instance.Length + " routes enregistrées");

    await NotificationToolbar.Instance.FetchMessage("Waiting fetch ..")
    await TokenHelper.Instance.CheckToken();

    $("#panel-vertical").kendoSplitter({
        orientation: "vertical",
        panes: [
            {collapsible: false, size: "80px", resizable: false},
            {collapsible: false},
            {collapsible: false, size: "30px", resizable: false}
        ]
    });

    $("#panel-middle").kendoSplitter({
        orientation: "horizontal",
        panes: [
            {collapsible: false, size: "250px", resizable: true},
            {collapsible: false,},
        ]
    });

    new Header({jqMainContainer: $("#panel-top")});
})